import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CommunicationService from "../../Controller/CommunicationController";
import CreateCommunication from "./CreateCommunication";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import InboxModal from "../../../Common/InboxModal";
import Cookies from "js-cookie";
function CommunicationPage({ LeadID, Tab, IsDiaries, CommunicationID, Phone, Mobile, CompanyName, ToEmail }) {

    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    const tableRef = useRef();
    const [CommunicationList, setCommunicationData] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentCommunicationHistory, setCurrentCommunicationHistory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [inboxModalOpen, setInboxModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [inboxLoading, setInboxLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);

    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`LeadCommSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`LeadCommSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());





    useEffect(() => {
        fetchCommunication(currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchCommunication(currentPage, pageSize);

    }, [sortConfig]);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const fetchCommunication = async (page, size) => {
        try {
            setLoading(true);
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            let data = await CommunicationService.GetLeadCommunication(redirectCallback, LeadID, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "", searchColumns);
            setCommunicationData(data);

            debugger;
            if (IsDiaries === "1" && CommunicationID > 0) {

                data = data.filter(a => a.ID === CommunicationID);
                handleEditClick(data[0]);
            }
            // 

            const leadCount = await CommunicationService.GetLeadCommunicationCount(redirectCallback, LeadID, searchQuery, "", searchOptions.toString(), "0");
            setPOCount(leadCount[0].TotalRecords);
            setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };

    useEffect(() => {
        if (LeadID > 0) {
            fetchCommunication(currentPage, pageSize);

        }
    }, [LeadID, Tab]);

    const handleCreateCommunicationClick = () => {
        setCurrentCommunicationHistory(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (history) => {
        debugger;
        setCurrentCommunicationHistory(history);
        setIsModalOpen(true);
    };
    const handleSuccess = async () => {
        await fetchCommunication(currentPage, pageSize); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await CommunicationService.DeleteCommunication(ID, redirectCallback);
                    $(tableRef.current).DataTable().destroy();
                    fetchCommunication(currentPage, pageSize);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';  // Return empty string if text is null or empty
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleInboxSave = (selectedEmails) => {
        const selected = selectedEmails[0];
        if (!selected) return;
        setIsModalOpen(true);
        setCurrentCommunicationHistory({
            snt_CommunicationType: "1",
            vc_From: selected.from,
            vc_To: localStorage.getItem("Email"),
            vc_Subject: selected.subject,
            vc_Description: selected.body || "",
        });
    };

    // ✅ Show Inbox button handler
    const handleShowInbox = () => {
        setInboxModalOpen(true);
    };
    const handleCloseInbox = () => {
        setInboxModalOpen(false);
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const defaultColumns = [
        "ID",
        "dt_Created",
        "snt_CommunicationType",
        "DueDate",
        "vc_Description",
        "AppointmentDate",
        "UserTask",
        "DisplayName",
        "StatusText",
        "EmailStatus"
    ];
    const defaultColumnsForSearch = [
        "ID",
        "dt_Created",
        "snt_CommunicationType",
        "DueDate",
        "vc_Description",
        "AppointmentDate",
        "UserTask",
        "DisplayName",
        "StatusText",
        "EmailStatus"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "ID", label: "ID" },
        { value: "dt_Created", label: "dt_Created" },
        { value: "snt_CommunicationType", label: "snt_CommunicationType" },
        { value: "DueDate", label: "DueDate" },
        { value: "vc_Description", label: "vc_Description" },
        { value: "AppointmentDate", label: "AppointmentDate" },
        { value: "UserTask", label: "UserTask" },
        { value: "DisplayName", label: "DisplayName" },
        { value: "StatusText", label: "StatusText" },
        { value: "EmailStatus", label: "EmailStatus" }
    ];
    const columnSearchOptions = [
        { value: "ID", label: "ID" },
        { value: "dt_Created", label: "dt_Created" },
        { value: "snt_CommunicationType", label: "snt_CommunicationType" },
        { value: "DueDate", label: "DueDate" },
        { value: "vc_Description", label: "vc_Description" },
        { value: "AppointmentDate", label: "AppointmentDate" },
        { value: "UserTask", label: "UserTask" },
        { value: "DisplayName", label: "DisplayName" },
        { value: "StatusText", label: "StatusText" },
        { value: "EmailStatus", label: "EmailStatus" },
        { value: "Actions", label: "Actions" },


    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`leadCommColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`leadCommColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page

        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await CommunicationService.GetLeadCommunication(redirectCallback, LeadID, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "", searchColumns);
        setCommunicationData(locationData);

        const leadCount = await CommunicationService.GetLeadCommunicationCount(redirectCallback, LeadID, searchQuery, "", columnsToSearch.toString(), "0");
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await CommunicationService.GetLeadCommunication(redirectCallback, LeadID, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "", searchColumns);
        setCommunicationData(locationData);

    };
    const handlePageChange = (page) => {
        setCommunicationData([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const getInitialWidths = () => {
        const saved = Cookies.get(`LeadCommColumnWidths_${CompanyID}_${UserID}`);
        const defaults = {};

        visibleColumns.forEach(col => {
            defaults[col] = 110;
        });

        if (!saved) return defaults;

        const parsed = JSON.parse(saved);
        const applied = {};

        visibleColumns.forEach(col => {
            applied[col] = parsed[col] || 110;
        });

        return applied;
    };
    const [columnWidths, setColumnWidths] = useState(getInitialWidths);
    const startX = useRef(0);
    const startWidth = useRef(0);
    const resizingColumn = useRef(null);
    const MIN_COL_WIDTH = 60;
    const startResize = (e, key) => {
        e.stopPropagation();
        startX.current = e.clientX;
        resizingColumn.current = key;

        const th = e.target.closest("th");   // FIXED HERE
        startWidth.current = th.offsetWidth;

        document.addEventListener("mousemove", resizeColumn);
        document.addEventListener("mouseup", stopResize);
    };
    const resizeColumn = (e) => {
        if (!resizingColumn.current) return;

        const delta = e.clientX - startX.current;
        const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

        setColumnWidths(prev => ({
            ...prev,
            [resizingColumn.current]: newWidth
        }));
    };
    useEffect(() => {
        setColumnWidths(getInitialWidths());
    }, [visibleColumns]);
    const stopResize = () => {
        document.removeEventListener("mousemove", resizeColumn);
        document.removeEventListener("mouseup", stopResize);

        const key = resizingColumn.current;
        if (key) {
            setColumnWidths(prev => {
                // Save using the most recent updated state
                Cookies.set(
                    `LeadCommColumnWidths_${CompanyID}_${UserID}`,
                    JSON.stringify(prev),
                    { expires: 365 }
                );
                return prev;
            });
        }

        resizingColumn.current = null;
    };
    const autoFitColumn = (key) => {
        const cells = document.querySelectorAll(`[data-col='${key}']`);
        let maxWidth = 0;

        cells.forEach(cell => {
            maxWidth = Math.max(maxWidth, cell.scrollWidth);
        });

        const newWidth = maxWidth + 20;

        const updated = { ...columnWidths, [key]: newWidth };

        setColumnWidths(updated);

        Cookies.set(
            `LeadCommColumnWidths_${CompanyID}_${UserID}`,
            JSON.stringify(updated),
            { expires: 365 }
        );
    };
    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3">
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateCommunicationClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>

                    </button>

                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3">

                <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                    </select>
                </div>
                <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                <div className="col-sm-6"></div>
                <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>


                </div>
                <div className="col-sm-2 d-flex justify-content-end">
                    <input
                        list="recent-searches"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="form-control me-2"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchButtonClick();
                            }
                        }}
                    />

                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                        <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-sm-12">

                    <div style={{ maxHeight: "60vh", overflow: "auto" }}>

                        <table style={{ tableLayout: "fixed" }} className="table m-0 table-hover">
                            <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>


                                <tr>
                                    <th style={{
                                        width: `${columnWidths?.dt_Created}px`,
                                        minWidth: `${MIN_COL_WIDTH}px`
                                    }}
                                        className="resizable ellipsis">Created
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "dt_Created");
                                            }}
                                            onDoubleClick={() => autoFitColumn("dt_Created")}
                                        /></th>
                                    <th

                                        style={{
                                            width: `${columnWidths?.snt_CommunicationType}px`,
                                            minWidth: `${MIN_COL_WIDTH}px`
                                        }}
                                        className="resizable ellipsis">Type
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "snt_CommunicationType");
                                            }}
                                            onDoubleClick={() => autoFitColumn("snt_CommunicationType")}
                                        />

                                    </th>
                                    <th
                                        style={{
                                            width: `${columnWidths?.vc_Description}px`,
                                            minWidth: `${MIN_COL_WIDTH}px`
                                        }}
                                        className="resizable ellipsis">Description
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "vc_Description");
                                            }}
                                            onDoubleClick={() => autoFitColumn("vc_Description")}
                                        /></th>

                                    <th style={{
                                        width: `${columnWidths?.DueDate}px`,
                                        minWidth: `${MIN_COL_WIDTH}px`
                                    }}
                                        className="resizable ellipsis">Due Date
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "DueDate");
                                            }}
                                            onDoubleClick={() => autoFitColumn("DueDate")}
                                        /></th>
                                    <th

                                        style={{
                                            width: `${columnWidths?.UserTask}px`,
                                            minWidth: `${MIN_COL_WIDTH}px`
                                        }}
                                        className="resizable ellipsis">Assigned To
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "UserTask");
                                            }}
                                            onDoubleClick={() => autoFitColumn("UserTask")}
                                        />

                                    </th>
                                    <th style={{
                                        width: `${columnWidths?.DisplayName}px`,
                                        minWidth: `${MIN_COL_WIDTH}px`
                                    }}
                                        className="resizable ellipsis">Action By
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "DisplayName");
                                            }}
                                            onDoubleClick={() => autoFitColumn("DisplayName")}
                                        /></th>
                                    <th
                                        style={{
                                            width: `${columnWidths?.EmailStatus}px`,
                                            minWidth: `${MIN_COL_WIDTH}px`
                                        }}
                                        className="resizable ellipsis">Status
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "EmailStatus");
                                            }}
                                            onDoubleClick={() => autoFitColumn("EmailStatus")}
                                        /></th>
                                    <th style={{
                                        width: `${columnWidths?.Actions}px`,
                                        minWidth: `${MIN_COL_WIDTH}px`
                                    }}
                                        className="resizable ellipsis">Actions
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.stopPropagation();   // STOP the click event from bubbling
                                                startResize(e, "Actions");
                                            }}
                                            onDoubleClick={() => autoFitColumn("Actions")}
                                        /></th>
                                </tr>

                            </thead>
                            <tbody>
                                {CommunicationList.map((comm, index) => (
                                    <tr key={comm.ID}
                                        onClick={comm.ID > 0 && localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(comm, index) : undefined}
                                        style={{ cursor: 'pointer' }}>
                                        <td
                                            style={{
                                                width: columnWidths.dt_Created,
                                                minWidth: MIN_COL_WIDTH,
                                            }} className="no-wrap ellipsis"
                                            data-order={new Date(comm.dt_Created).toISOString()}
                                        >
                                            {formatDate(comm.dt_Created)}
                                        </td>
                                        <td style={{
                                            width: columnWidths.snt_CommunicationType,
                                            minWidth: MIN_COL_WIDTH,
                                        }} className="no-wrap ellipsis">
                                            {(() => {
                                                switch (comm.snt_CommunicationType.toString()) {
                                                    case "0":
                                                        return "Notes";
                                                    case "1":
                                                        return "Email";
                                                    case "2":
                                                        return "Task";
                                                    case "3":
                                                        return "Appointment";
                                                    default:
                                                        return "Notes";
                                                }
                                            })()}
                                        </td>


                                        <td
                                            style={{
                                                width: columnWidths.vc_Description,
                                                minWidth: MIN_COL_WIDTH,
                                                maxWidth: columnWidths.vc_Description,
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: comm.vc_Description }}
                                        ></td>

                                        <td style={{
                                            width: columnWidths.DueDate,
                                            minWidth: MIN_COL_WIDTH,
                                        }} className="no-wrap ellipsis">
                                            {(() => {
                                                switch (comm.snt_CommunicationType.toString()) {
                                                    case "0":
                                                        return "";
                                                    case "1":
                                                        return "";
                                                    case "2":
                                                        return comm.DueDate ? formatDate(comm.DueDate) : ""
                                                    case "3":
                                                        return comm.AppointmentDate ? formatDate(comm.AppointmentDate) : ""
                                                    default:
                                                        return "";
                                                }
                                            })()}
                                        </td>
                                        <td style={{
                                            width: columnWidths.UserTask,
                                            minWidth: MIN_COL_WIDTH,
                                        }} className="no-wrap ellipsis">{comm.UserTask}</td>
                                        <td style={{
                                            width: columnWidths.DisplayName,
                                            minWidth: MIN_COL_WIDTH,
                                        }} className="no-wrap ellipsis">{comm.DisplayName}</td>
                                        <td style={{
                                            width: columnWidths.EmailStatus,
                                            minWidth: MIN_COL_WIDTH,
                                        }} className="no-wrap ellipsis">
                                            {comm.snt_CommunicationType.toString() === "2" || comm.snt_CommunicationType.toString() === "3"
                                                ? comm.StatusText
                                                : comm.snt_CommunicationType.toString() === "1"
                                                    ? comm.EmailStatus
                                                    : ""}
                                        </td>
                                        <td style={{
                                            width: columnWidths.Actions,
                                            minWidth: MIN_COL_WIDTH,
                                        }} className={`no-wrap ellipsis ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, comm.ID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                                <tr>
                                    <td colSpan="8">
                                        <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                                            {/* Last Page Button */}
                                            <button
                                                style={{ float: "right", marginLeft: "5px" }}
                                                className='btn btn-info'
                                                onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                disabled={currentPage === totalPages}
                                            >
                                                <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} />  Last
                                            </button>

                                            {/* Next Page Button */}
                                            <button
                                                style={{ float: "right", marginLeft: "5px" }}
                                                className='btn btn-info'
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} />  Next
                                            </button>

                                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                Page {currentPage} of {totalPages}
                                            </span>

                                            {/* Previous Page Button */}
                                            <button
                                                style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                className='btn btn-info'
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                                            </button>

                                            {/* First Page Button */}
                                            <button
                                                style={{ float: "right" }}
                                                className='btn btn-info'
                                                onClick={() => handlePageChange(1)} // Navigate to first page
                                                disabled={currentPage === 1}
                                            >
                                                <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} />   First
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateCommunication
                    modalInstance={modalInstance}
                    currentCommunicationHistory={currentCommunicationHistory}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    LeadID={LeadID}
                    IsDiaries={IsDiaries}
                    CommunicationID={CommunicationID}
                    Phone={Phone}
                    Mobile={Mobile}
                    CompanyName={CompanyName}
                    ToEmail={ToEmail}

                />
            )}
            {inboxModalOpen && (
                <InboxModal onSave={handleInboxSave} onClose={handleCloseInbox} />
            )}
        </div>
    );
}

export default CommunicationPage;
